import $ from 'jquery';

import serverStorage from "./modules/server-storage";
import session from "./modules/session";
import coupon from "./modules/coupon";
import login from "./modules/login";
import fujisanReader from "./modules/fujisan-reader";

import "../css/style.scss"

// FMSオブジェクトを作る
window.FMS = {
  serverStorage,
  session,
  coupon,
  login,
  fujisanReader
}

$(function() {
  // パスコード不要の場合は
  // pwlogin(wpAjax, '.js_pwSubmit', '.js_pwEmail', '.js_pwPassword', '.js_pwError', false, loader);

  session._login('.js_pwForm', '.js_pwSubmit', '.js_pwEmail', '.js_pwPassword', '.js_pwError', '.js_pwCode');
  session._logout('.js_pwLogout');
});
